import React, { ChangeEvent, CSSProperties, useEffect, useRef } from "react";

import {
  Button,
  Checkbox,
  Dropdown,
  Form,
  FormField,
  Icon,
  Input,
  Popup,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";

import SearchBoxWithKey from "react-lib/appcon/common/SearchBoxWithKey";

import AutoResizeTextArea from "react-lib/apps/common/AutoResizeTextArea";

import "./TableTreatmentPlan.scss";

import { getFilteredDivisions, RehabPlanItemDetailType } from "./RHBInterface";

type TableTreatmentPlanProps = {
  onEvent: any;
  allDivisionList?: Record<string, any>[];
  data?: Partial<RehabPlanItemDetailType>[];
  deleteDataIdx: (index: number) => void;
  totalsError?: number[];
  searchedItemListWithKey: any;
  onChangeTableData: (index: number, key: string, value: any) => void;
  onOpenGallery: (index: number) => void;
};

const IMAGES = {
  gallery: "/static/images/rehab/gallery.png",
  gallery_grey: "/static/images/rehab/gallery-grey.png",
};

const TableTreatmentPlan = (props: TableTreatmentPlanProps) => {
  // const [edit, setEdit] = useState<{ key: string; row: number } | null>(null);

  console.log(" TableTreatmentPlan props:", props);

  return (
    <Form
      onSubmit={(e) => {
        alert("onSubmit");
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Table id="TableTreatmentPlan" celled compact structured>
        <TableHeader className="rehab-treatment-plan">
          <TableRow>
            <TableHeaderCell rowSpan="2" textAlign="center" width={3}>
              Treatment
            </TableHeaderCell>
            <TableHeaderCell rowSpan="2" textAlign="center" width={5}>
              Detail
            </TableHeaderCell>
            <TableHeaderCell rowSpan="2" textAlign="center">
              Image
            </TableHeaderCell>
            <TableHeaderCell rowSpan="2" textAlign="center" width={3}>
              To Department <span style={{ color: "red" }}>*</span>
            </TableHeaderCell>
            <TableHeaderCell rowSpan="2" textAlign="center" width={4}>
              ICD-09
            </TableHeaderCell>
            <TableHeaderCell colSpan="2" textAlign="center" width={1}>
              Frequency (time/day)&nbsp;&nbsp;&nbsp;
              <Popup
                content="If you would like to set it independently, please specify in the detail field"
                trigger={<Icon color="blue" name="info circle" />}
              />
            </TableHeaderCell>
            <TableHeaderCell rowSpan="2" textAlign="center" width={1}>
              Total (Time(s))
            </TableHeaderCell>
            <TableHeaderCell rowSpan="2" textAlign="center" />
          </TableRow>
          <TableRow>
            <TableHeaderCell textAlign="center">Time(s)/week</TableHeaderCell>
            <TableHeaderCell textAlign="center">Duration(Week(s))</TableHeaderCell>
          </TableRow>
        </TableHeader>

        <TableBody>
          {props.data?.length === 0 || props.data === undefined ? (
            <TableCell style={{ color: "grey" }} colSpan="9" textAlign="center">
              Please add treatment plan
            </TableCell>
          ) : null}
          {(props.data ?? []).map((item, index: number) => {
            const codeText = item.icd9Data?.icd10_id ? `[${item.icd9Data.icdcode}]` : "";
            const termText = item.icd9Data?.icdterm ? ` ${item.icd9Data.icdterm}` : "";
            const defaultCodeTerm = `${codeText}${termText}`;
            const divisionOptions = getFilteredDivisions(props.allDivisionList, item.divisions);
            return (
              <TableRow
                key={index}
                className="--override-disabled --grey"
                disabled={item.status === "X"}
              >
                <TableCell verticalAlign="top">{item.productName}</TableCell>
                <TableCell verticalAlign="top">
                  <div style={{ margin: "-7px -9px" }}>
                    <AutoResizeTextArea
                      value={item.detail ?? ""}
                      onChange={(value) => {
                        props.onChangeTableData(index, "detail", value);
                      }}
                    />
                  </div>
                </TableCell>
                <TableCell textAlign="center" verticalAlign="top">
                  <img
                    style={{ cursor: "pointer", height: "25px" }}
                    alt="gallery.icon"
                    src={(item.images ?? []).length > 0 ? IMAGES.gallery : IMAGES.gallery_grey}
                    onClick={() => {
                      props.onOpenGallery(index);
                    }}
                  />
                </TableCell>
                <TableCell verticalAlign="top">
                  <Dropdown
                    value={item.to_department_for_doctor}
                    fluid
                    search
                    selection
                    options={divisionOptions}
                    onChange={(e, data) => {
                      props.onChangeTableData(index, "to_department_for_doctor", data.value);
                    }}
                  />{" "}
                </TableCell>
                <TableCell verticalAlign="top">
                  <div
                    style={{
                      alignItems: "flex-end",
                      display: "flex",
                      flexDirection: "column",
                      gap: "1em",
                    }}
                  >
                    <SearchBoxWithKey
                      onEvent={props.onEvent}
                      id={`ICD9CMCodeTermMedTerm_${index}`}
                      defaultText={defaultCodeTerm}
                      placeholder="Search Medical term/ICD-09 term/ ICD-09 Code"
                      selectedItem={item.icd9Data?.icd10_id}
                      type="ICD9CMCodeTermMedTerm"
                      valueKey="icd10_id"
                      searchedItemListWithKey={props.searchedItemListWithKey}
                      mapOptions={(items: any[]) =>
                        items.filter(Boolean).map((acc) => ({
                          key: acc.icd10_id,
                          text: item.icd9Data?.icd10_id
                            ? `[${acc.icdcode}] ${acc.icdterm}`
                            : `[${acc.icdcode}] [${acc.medterm}] ${acc.icdterm}`,
                          value: acc.icd10_id,
                          content: `[${acc.icdcode}] ${acc.icdterm}`,
                        }))
                      }
                      setSelected={(value, key, data) => {
                        props.onChangeTableData(index, "icd9Data", data);
                      }}
                    />

                    <Checkbox
                      style={{ width: "fit-content" }}
                      checked={item.icd9_type === "PRIMARY"}
                      disabled={!item.icd9cm && !item.icd9Data}
                      label="is primary"
                      onChange={(e, data) => {
                        props.onChangeTableData(
                          index,
                          "icd9_type",
                          data.checked ? "PRIMARY" : "SECONDARY"
                        );
                      }}
                    />
                  </div>
                </TableCell>
                <TableCell textAlign="center" verticalAlign="top">
                  <Input
                    style={{ width: "70px" }}
                    disabled={(item.performed_count ?? 0) > 0}
                    min={0}
                    type="number"
                    value={item.frequency}
                    onChange={(e, data) => {
                      if (item.duration) {
                        const total = Number(data.value) * item.duration;

                        props.onChangeTableData(index, "total_for_doctor", total);
                      }

                      props.onChangeTableData(index, "frequency", Number(data.value));
                    }}
                  />
                </TableCell>
                <TableCell textAlign="center" verticalAlign="top">
                  <Input
                    style={{ width: "70px" }}
                    disabled={(item.performed_count ?? 0) > 0}
                    min={0}
                    type="number"
                    value={item.duration}
                    onChange={(e, data) => {
                      if (item.frequency) {
                        const total = Number(data.value) * item.frequency;

                        props.onChangeTableData(index, "total_for_doctor", total);
                      }

                      props.onChangeTableData(index, "duration", Number(data.value));
                    }}
                  />
                </TableCell>
                <TableCell textAlign="center" verticalAlign="top">
                  <Form style={{ position: "relative" }}>
                    <FormField error={props.totalsError?.includes(index)}>
                      <Input
                        style={{ width: "70px" }}
                        disabled={(item.performed_count ?? 0) > 0}
                        min={0}
                        type="number"
                        value={item.total_for_doctor}
                        onChange={(e, data) => {
                          props.onChangeTableData(index, "total_for_doctor", Number(data.value));
                        }}
                      />

                      {props.totalsError?.includes(index) && (
                        <div
                          style={{
                            bottom: "-1.75rem",
                            color: "#9f3a38",
                            fontSize: "0.7rem",
                            lineHeight: "1.25",
                            position: "absolute",
                            textAlign: "left",
                          }}
                        >
                          <div>Please enter</div>
                          <div>the information</div>
                        </div>
                      )}
                    </FormField>
                  </Form>
                </TableCell>
                <TableCell textAlign="center" verticalAlign="top">
                  <Button
                    style={{ marginTop: "0.3rem", display: item.status === "X" ? "none" : "" }}
                    color="red"
                    disabled={(item.performed_count ?? 0) > 0}
                    size="mini"
                    type="button"
                    icon
                    onClick={() => {
                      props.deleteDataIdx(index);
                      console.log("Delete !!! ");
                    }}
                  >
                    <Icon name="minus" />
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Form>
  );
};

TableTreatmentPlan.displayName = "TableTreatmentPlan";

export default React.memo(TableTreatmentPlan);
